<div class="input-search-container" #rootElement>
  <div class="input-container" [ngClass]="{'disabled': disabled, 'selected': inputValue,
    'has-warning': required && (inputText.errors && (inputText.dirty || inputText.touched))}">

    <input #inputText
      type="text"
      class="input-search crm-field"
      autocomplete="off"
      [ngClass]="{'hidden': inputValue, 'regular': regular}"
      [name]="name"
      [(ngModel)]="searchQuery"
      [disabled]="disabled"
      [placeholder]="placeholder"
      [required]="required"
      [readonly]="regular"
      (focus)="onShow()"
      (blur)="onBlur()"
      (keydown.arrowdown)="onKeyArrowDown($event)"
      (keydown.arrowup)="onKeyArrowUp($event)"
      (keydown.enter)="onKeyEnter($event)" />

    <div class="value" *ngIf="inputValue">{{inputValue ? getValue(inputValue) : placeholder}}</div>

    <ng-container *ngIf="!isNoDropIcon">
      <a *ngIf="!inputValue" (click)="onShow()" [ngClass]="{'disabled': disabled}" class="dropdown-button">
        <i class="fa fa-angle-down" aria-hidden="true"></i>
      </a>
    </ng-container>

    <a class="lock-icon" *ngIf="inputValue && !disabled" (click)="onClear()">
      <i class="fa fa-times" aria-hidden="true"></i>
    </a>

    <span class="help-block" *ngIf='required && (inputText.errors && (inputText.dirty || inputText.touched))'>
      required
    </span>
  </div>

  <div *ngIf="isOpen && !isNoDropIcon" class="dropdown-items" [ngClass]="{'bottom': !topFlag ,'top': topFlag}">
    <div *ngIf="isLoading" class="loading-container">
      <div class="loading-icon-small"></div>
    </div>

    <div #container (scroll)="onScrollHandler($event)" *ngIf="!isLoading" id="DROPDOWN_ITEMS" class="item-container">
      <ng-container *ngIf="preset?.length > 0">
        <div class="header" *ngIf="presetHeader">{{presetHeader}}</div>
        <div class="item preset" [id]="'PRESET_ITEMS_' + i" [ngClass]="{'active': p.active, 'offset': presetHeader}"
          (click)="onSelected(p)" *ngFor="let p of preset; let i=index">
          {{displayFull ? p.getFullDetails() : p.getName()}}
        </div>
      </ng-container>

      <ng-container *ngIf="items.length > 0">
        <div class="header" *ngIf="itemsHeader">{{itemsHeader}}</div>

        <div class="item" [id]="'ITEMS_' + i" [ngClass]="{'active': c.active, 'offset': presetHeader}" (click)="onSelected(c)"
          *ngFor="let c of items; let i=index">
          {{displayFull ? c.getFullDetails() : c.getName()}}
        </div>
      </ng-container>

      <ng-container *ngIf="(!(items.length > 0) && searchQuery?.length > 0 && !userInputAllowed)">
        <div class="item no-records-found">
          No Records Found
        </div>
      </ng-container>
    </div>

    <div *ngIf="showCreate" class="bottom-btn">
      <button (click)="createNewAction()" class="btn btn-link"> <i class="fa fa-plus"></i> Create new </button>
    </div>

    <div *ngIf="showManage" class="bottom-btn">
      <button (click)="onManage()" class="btn btn-link"> Manage </button>
    </div>
  </div>
</div>
